export default {
    courses: 'Basiscursussen',
    deep_dive: 'Verdiepende cursussen',
    finalquiz: 'Eindtoetsen',
    back_to_menu: 'Terug naar de cursussen',
    home: 'Startpagina',
    new_chapter: 'nieuw hoofdstuk',
    new_chapter_plural: 'nieuwe hoofdstukken'
}
